import axios from '../axios';

export const getEnabled = () =>
  new Promise<any[]>((resolve, reject) => {
    axios
      .get('/conclusionStatus')
      .then(({ data }) => resolve(data))
      .catch(reject);
  });
